type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
};

export function PageHeader({ eyebrow, title, description }: PageHeaderProps) {
  return (
    <section className="border-b border-line bg-sand py-16 md:py-24">
      <div className="container">
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h1 className="max-w-4xl text-[2.25rem] font-bold leading-[1.3] text-charcoal md:text-[3.25rem] md:leading-[1.25]">
          {title}
        </h1>
        {description ? (
          <p className="mt-5 max-w-3xl text-lg leading-9 text-ash">
            {description}
          </p>
        ) : null}
      </div>
    </section>
  );
}
